import React, { FunctionComponent, useEffect, useState } from "react";
import {
  FormControlLabel,
  Grid,
  Radio,
  RadioGroup,
  Typography,
} from "@material-ui/core";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Box from "@material-ui/core/Box";
import { SuspendedBills } from "./SuspendedView/SuspendedBills";
import { useSuspendedBillStyles } from "./useSuspendedBillStyles";
import { SuspendedBillDetails } from "./SuspendedView/SuspendedBillDetails";
import { SnackBar } from "../SnackBar";
import { api } from "../../api";
import { Helmet } from "react-helmet-async";
import { SuspendedBillSearch } from "./SuspendedView/SuspendedBillSearch";
import { AppLoadingScreen } from "../AppLoadingScreen";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

export const TabPanel: FunctionComponent<TabPanelProps> = ({
  children,
  value,
  index,
}) => {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      //   {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
};

export const SuspendedBillsMaster = () => {
  const classes = useSuspendedBillStyles();
  const [value, setValue] = React.useState(0);
  const [detailFlag, setDetailFlag] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<string>("");
  const [snackbarColor, setSnackbarColor] = useState<string>("#d50000");
  const [suspendedBillDetails, setSuspendedBillDetails] = useState<
    Array<object>
  >([]);
  const [billDetails, setBillDetails] = useState<any>({});
  const [listFlag, setListFlag] = useState<boolean>(false);
  const [listType, setListType] = useState<string>("currentday");
  const [suspendedBills, setSuspendedBills] = useState<any>([]);
  const [voucherValidity, setVoucherValidity] = useState<any>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  useEffect(() => {
    /* initially get the current day list */
    try {
      getSuspendedBills(listType);
    } catch (e:any) {
      setSnackbarColor("red");
      setErrorMessage(e.error);
      console.log("error..", e);
    }
  }, []);

  const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    setDetailFlag(newValue === 1 ? true : false);
    setValue(newValue);
  };

  const getSuspendedBills = async (radioType: string) => {
    /* getting the list with radio button value */
    try {
      setIsLoading(true);
      const billList = await api.get(
        `bills/suspended-list?time_period=${radioType}`
      );
      setVoucherValidity(billList.suspendend_voucher_validity);
      setSuspendedBills(billList);
      setIsLoading(false);
      setListFlag(true);
    } catch (error: any) {
      setSnackbarColor("red");
      setErrorMessage(error.error);
    }
  };

  const getBillDetails = async (value: number, billDocNo: number) => {
    /* getting the items list of a bill */
    try {
      setIsLoading(true);
      const billDetails = await api.get(
        `bills/${billDocNo}/suspended-product-list`
      );
      setSuspendedBillDetails(billDetails);
      const filteredDetails = suspendedBills.suspended_bills?.find(
        (i: any) => i.suspendend_bill_doc_number === billDocNo
      );
      setBillDetails(filteredDetails);
      setDetailFlag(value === 1 ? true : false);
      setIsLoading(false);
      setValue(value);
    } catch (error: any) {
      setSnackbarColor("red");
      setErrorMessage(error.error);
    }
  };

  const backToList = () => {
    setDetailFlag(false);
    setValue(0);
  };

  const onCloseSnackbar = () => {
    setErrorMessage("");
  };

  return (
    <>
      <Helmet>
        <title>Suspended bills</title>
      </Helmet>
      <Grid
        container
        spacing={2}
        direction="row"
        justify="space-between"
        alignItems="center"
      >
        <SnackBar
          status={errorMessage}
          onCloseError={onCloseSnackbar}
          color={snackbarColor}
        />
        <Grid item xs={12} className={classes.root}>
          <AppBar position="static">
            <Tabs
              value={value}
              onChange={handleChange}
              aria-label="simple tabs example"
            >
              <Tab label="Suspended Bills" />
              <Tab
                label="Bill Details"
                style={{ display: detailFlag ? "" : "none" }}
              />
              <Tab label="Suspended Bill Search" />
            </Tabs>
          </AppBar>
          <TabPanel value={value} index={0}>
            <Grid container spacing={2} direction="row" justify="space-between">
              <Grid item xs={12}>
                <RadioGroup
                  aria-label="position"
                  row
                  name="list_type"
                  onChange={(event: any) => {
                    setListType(event.target.value);
                    getSuspendedBills(event.target.value);
                  }}
                  value={listType}
                >
                  <FormControlLabel
                    value="currentday"
                    control={<Radio color="primary" />}
                    label="Current Day"
                    labelPlacement="end"
                  />
                  <FormControlLabel
                    value="yearly"
                    control={<Radio color="primary" />}
                    label="Yearly (only having suspended bills list)"
                    labelPlacement="end"
                  />
                </RadioGroup>
              </Grid>
              <Grid item xs={12}>
                {isLoading ? (
                  <AppLoadingScreen />
                ) : listFlag ? (
                  <SuspendedBills
                    suspendedBills={suspendedBills}
                    getBillDetails={getBillDetails}
                    listType={listType}
                  />
                ) : (
                  ""
                )}
              </Grid>
            </Grid>
          </TabPanel>
          <TabPanel value={value} index={1}>
            <SuspendedBillDetails
              suspendedBillDetails={suspendedBillDetails}
              billDetails={billDetails}
              backToList={backToList}
              searchView={false}
              voucherValidity={voucherValidity}
              listType={listType}
            />
          </TabPanel>
          <TabPanel value={value} index={2}>
            <SuspendedBillSearch />
          </TabPanel>
        </Grid>
      </Grid>
    </>
  );
};
